export default {
  lang: {
    selectAll: 'Выберите все страницы',
    selected: 'Выбранный',
    term: 'Полоска',
    deselect: 'Отмена выбора',
  },
};
